import React, { ReactNode } from "react";
import "./BannerView.css";
import MtiButton from "../Buttons/MtiButton";

type BannerViewProps = {
  title: string;
  message: ReactNode;
  onClickAbort: () => void;
};

export default function BannerView({
  title,
  message,
  onClickAbort,
}: Readonly<BannerViewProps>) {
  return (
    <div className="app-banner-container">
      <div className="banner-icon">
        <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M3.05023 19.8245L2.81556 19.6538C2.09781 19.1318 1.66669 18.253 1.66669 17.312C1.66669 16.8101 1.78967 16.3175 2.0229 15.8849L7.90694 4.97271C8.34324 4.16357 9.1395 3.66675 10 3.66675C10.8605 3.66675 11.6568 4.16357 12.0931 4.97271L17.9771 15.8849C18.2104 16.3175 18.3334 16.8101 18.3334 17.312C18.3334 18.253 17.9022 19.1318 17.1845 19.6538L16.9498 19.8245C16.4935 20.1563 15.9574 20.3334 15.409 20.3334H4.59106C4.04266 20.3334 3.50653 20.1563 3.05023 19.8245ZM10.8334 13.6667L11.6667 7.00008H8.33335L9.16669 13.6667H10.8334ZM11.6667 17.0001C11.6667 17.9206 10.9205 18.6667 10 18.6667C9.07955 18.6667 8.33335 17.9206 8.33335 17.0001C8.33335 16.0796 9.07955 15.3334 10 15.3334C10.9205 15.3334 11.6667 16.0796 11.6667 17.0001Z" fill="#FFCA0A" />
          <path fill-rule="evenodd" clip-rule="evenodd" d="M3.05023 19.8245L2.81556 19.6538C2.09781 19.1318 1.66669 18.253 1.66669 17.312C1.66669 16.8101 1.78967 16.3175 2.0229 15.8849L7.90694 4.97271C8.34324 4.16357 9.1395 3.66675 10 3.66675C10.8605 3.66675 11.6568 4.16357 12.0931 4.97271L17.9771 15.8849C18.2104 16.3175 18.3334 16.8101 18.3334 17.312C18.3334 18.253 17.9022 19.1318 17.1845 19.6538L16.9498 19.8245C16.4935 20.1563 15.9574 20.3334 15.409 20.3334H4.59106C4.04266 20.3334 3.50653 20.1563 3.05023 19.8245ZM10.8334 13.6667L11.6667 7.00008H8.33335L9.16669 13.6667H10.8334ZM11.6667 17.0001C11.6667 17.9206 10.9205 18.6667 10 18.6667C9.07955 18.6667 8.33335 17.9206 8.33335 17.0001C8.33335 16.0796 9.07955 15.3334 10 15.3334C10.9205 15.3334 11.6667 16.0796 11.6667 17.0001Z" fill="#FFCA0A" />
        </svg>

      </div>
      <span className="banner-title">{title}</span>
      {typeof message === "string" ? (
        <pre style={{ whiteSpace: "pre-wrap" }} className="banner-message">
          {message}
        </pre>
      ) : (
        message
      )}
      <div className="banner-buttons">
        <MtiButton size="small" variant="secondary" colorVariant="black" onClick={onClickAbort} style={{height: "30px", minWidth: "80px"}}>
          {"Abort"}
        </MtiButton>
      </div>
    </div>
  );
}
